import { render, staticRenderFns } from "./ruleTemplate.vue?vue&type=template&id=a750d468"
import script from "./ruleTemplate.vue?vue&type=script&lang=js"
export * from "./ruleTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports